import { TagUtil, Util } from 'Lib';

// Tag helpers live in their own library export rather than under Util, but are
// surfaced here alongside the rest so callers have a single import site.
const { getTagValue, setTagValue } = TagUtil;

const {
  areEquivalent,
  areSetsEqual,
  downloadBlob,
  formatBytes,
  formatMoney,
  formatMoneyWithSign,
  getBreadcrumb,
  getClickableLink,
  getNameWithInactiveTag,
  groupToMap,
  isAuthorized,
  isItemInactive,
  isUserAuthorized,
  roundToHundredth,
} = Util;

export {
  downloadBlob,
  formatBytes,
  formatMoney,
  formatMoneyWithSign,
  roundToHundredth,
  getClickableLink,
  areEquivalent,
  groupToMap,
  isUserAuthorized,
  isAuthorized,
  getNameWithInactiveTag,
  isItemInactive,
  areSetsEqual,
  getBreadcrumb,
  getTagValue,
  setTagValue,
};
